import axios from '../Helpers/axios';
import { toast } from 'react-toastify';
import { buildQueryString } from '../Utils/Utils';

/**
 * Fetch ALPS folders with optional filtering
 * @param {Object} params - Query parameters
 * @param {string} params.query - Search query
 * @param {string} params.startDate - Start date filter
 * @param {string} params.endDate - End date filter
 * @param {number} params.limit - Number of items per page
 * @param {number} params.offset - Pagination offset
 * @returns {Promise} API response
 */
export const getAlpsFolders = (params = {}) => {
    const queryString = buildQueryString(params);
    const url = `/api/console/alps-folders?${queryString}`;

    return axios.get(url)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
            throw new Error('Failed to fetch ALPS folders');
        })
        .catch((error) => {
            toast.error('Error fetching ALPS folders: ' + (error.response?.data?.message || error.message));
            throw error;
        });
};

/**
 * Download ALPS folders data as CSV
 * @param {Object} params - Query parameters for filtering
 * @returns {Promise} Blob response for file download
 */
export const downloadAlpsCsv = (params = {}) => {
    const queryString = buildQueryString(params);
    const url = `/api/console/alps-folders/csv${queryString}`;

    return axios.get(url, { responseType: 'blob' })
        .then((response) => {
            if (response.status === 200) {
                return response;
            }
            throw new Error('Failed to download CSV');
        })
        .catch((error) => {
            toast.error('Error downloading CSV: ' + (error.response?.data?.message || error.message));
            throw error;
        });
};

/**
 * Update ALPS note for a specific folder
 * @param {string} folderId - The folder ID
 * @param {string} alpsNote - The new ALPS note content
 * @returns {Promise} API response with updated folder data
 */
export const updateAlpsNote = (folderId, alpsNote) => {
    return axios.patch(`/api/console/folders/${folderId}`, { alpsNote })
        .then((response) => {
            if (response.status === 200) {
                toast.success('ALPS note updated successfully');
                return response.data;
            }
            throw new Error('Failed to update ALPS note');
        })
        .catch((error) => {
            toast.error('Error updating ALPS note: ' + (error.response?.data?.message || error.message));
            throw error;
        });
};
